import { Button, Card, List, Space, Tag, Tooltip, Typography } from 'antd'
import {
  knowledgeProblemTypeColor,
  knowledgeProductDisplay,
} from '@/modules/knowledge/constants'
import type { KnowledgeProductStat } from '@/types/knowledge'

const { Text } = Typography

interface Props {
  products: KnowledgeProductStat[]
  loading: boolean
  // undefined 表示不按产品过滤；空串表示只看未归类
  selectedProductKey: string | undefined
  onSelect: (productKey: string | undefined) => void
}

/** 产品维度浏览：产品名 + 知识条数 + 行业 Tag。product_key 为空的行展示为"未归类/仅行业" */
export default function KnowledgeProductPanel({
  products,
  loading,
  selectedProductKey,
  onSelect,
}: Props) {
  return (
    <Card
      size="small"
      title="产品维度"
      styles={{ body: { padding: 8 } }}
      style={{ width: 300, flex: '0 0 auto' }}
    >
      <Button
        block
        type={selectedProductKey === undefined ? 'primary' : 'text'}
        style={{ textAlign: 'left', marginBottom: 4 }}
        onClick={() => onSelect(undefined)}
      >
        全部产品
      </Button>
      <List
        size="small"
        loading={loading}
        dataSource={products}
        locale={{ emptyText: '暂无产品维度数据' }}
        renderItem={(item) => {
          const selected = selectedProductKey === item.product_key
          return (
            <List.Item
              onClick={() => onSelect(item.product_key)}
              style={{
                cursor: 'pointer',
                borderRadius: 4,
                paddingInline: 8,
                background: selected ? '#e6f4ff' : undefined,
              }}
            >
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  {/* 彩页摘要作为悬浮提示，display_name 是提示里的彩页文件名 */}
                  <Tooltip
                    title={
                      item.summary ? (
                        <div>
                          <div>{item.summary}</div>
                          {item.display_name && (
                            <div style={{ marginTop: 4 }}>彩页文件：{item.display_name}</div>
                          )}
                        </div>
                      ) : null
                    }
                  >
                    <Text strong={selected} style={{ wordBreak: 'break-all' }}>
                      {knowledgeProductDisplay(
                        item.product_key,
                        item.product_name,
                        item.product_line,
                      )}
                    </Text>
                  </Tooltip>
                  <Tag color={selected ? 'blue' : 'default'}>{item.count}</Tag>
                </div>
                <Space size={4} wrap style={{ marginTop: 4 }}>
                  {item.product_key && item.product_line && (
                    <Tag color="blue">{item.product_line}</Tag>
                  )}
                  {item.by_problem_type.slice(0, 2).map((type) => (
                    <Tag key={type.value} color={knowledgeProblemTypeColor(type.value)}>
                      {type.label} {type.count}
                    </Tag>
                  ))}
                </Space>
              </div>
            </List.Item>
          )
        }}
      />
    </Card>
  )
}
